import React from "react";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

const data = [
    { speed: "< 3", hours: 250 },
    { speed: "< 40", hours: 180 },
    { speed: "< 60", hours: 90 },
    { speed: "< 67", hours: 40 },
    { speed: "< 77", hours: 70 },
    { speed: "< 83", hours: 50 },
    { speed: "< 88", hours: 50 },
    { speed: "< 92", hours: 40 },
    { speed: "< 111", hours: 80 },
    { speed: "> 111", hours: 20 },
];

export default function SpeedChart() {
    return (
        <div style={{ width: "100%", height: 350, position: "relative" }}>
            {/* Legend & Label in Top Left */}
            <div style={{ position: "absolute", top: 10, left: 20, display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ width: 20, height: 10, backgroundColor: "#9c137d", borderRadius: 2 }}></div>
                <span style={{ fontWeight: "bold", fontSize: 14 }}>Hours</span>
            </div>

            <h4 style={{ textAlign: "center", marginTop: 10 }}>Speed Chart</h4>
            <div style={{ position: "absolute", top: 10, right: 20, display: "flex", alignItems: "center", gap: 5,fontWeight: "bold", fontSize: 14 }}>
            <span style={{ fontWeight: "bold", fontSize: 13,  position: "relative" ,right:10}}>Total Distance :</span> <div>3,231</div>
                <span style={{ fontWeight: "bold", fontSize: 13 }}>Km</span>
            </div>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={data} margin={{ top: 50, right: 30, left: 20, bottom: 30 }}>
                    <defs>
                        <linearGradient id="topGradient" x1="0" y1="1" x2="0" y2="0">
                            <stop offset="100%" stopColor="#9c137d" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="speed" label={{ value: "Speed (km/h)", position: "insideBottom", dy: 10 }} />
                    <YAxis label={{ value: "Hours (h)", angle: -90, position: "insideLeft" }} />
                    <Tooltip />
                    <Bar dataKey="hours" fill="url(#topGradient)" barSize={40} />
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
